module.exports = __webpack_public_path__ + "static/media/allen.d6ea5641.jpg";